import { randFloat, randUrl } from '@ngneat/falso';
import * as Factory from 'factory.ts';
import { CameraTimeLapseFrameDetails } from 'features/cameras/cameras.types';

export const alertCameraTimelapseFrameFactory =
  Factory.Sync.makeFactory<CameraTimeLapseFrameDetails>({
    imageTimestamp: Factory.each((i) => i.toString()),
    imageUrl: Factory.each(() => randUrl()),
    azDeg: Factory.each(() => randFloat()),
    fovDeg: Factory.each(() => randFloat()),
  });
